import Cookies from 'js-cookie';
import { envVars } from './common';
// Get the language from the URL or fallback to 'en-us'
export var getLanguageFromUrl = function () {
    if (typeof window === 'undefined') {
        return;
    }
    var localeFromPath = window.location.pathname.split('/')[2];
    var localeFromQueryParam = new URLSearchParams(window.location.search).get('locale');
    var localeFromCookie = Cookies.get('USER_PREFERRED_LOCALE');
    if (localeFromPath &&
        envVars.SUPPORTED_LOCALES.find(function (locale) { return (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) === (localeFromPath === null || localeFromPath === void 0 ? void 0 : localeFromPath.toLowerCase()); })) {
        return localeFromPath;
    }
    if (localeFromQueryParam &&
        envVars.SUPPORTED_LOCALES.find(function (locale) { return (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) === (localeFromQueryParam === null || localeFromQueryParam === void 0 ? void 0 : localeFromQueryParam.toLowerCase()); })) {
        return localeFromQueryParam;
    }
    if (localeFromCookie &&
        envVars.SUPPORTED_LOCALES.find(function (locale) { return (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) === (localeFromCookie === null || localeFromCookie === void 0 ? void 0 : localeFromCookie.toLowerCase()); })) {
        return localeFromCookie;
    }
    return envVars.DEFAULT_LOCALE.toLowerCase();
};
